import React, { useRef,useEffect, useState, useCallback  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables"; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import IconButton from '@mui/material/IconButton'; 
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import NTSearchStores from "pages/NT/editOrCreateNT/NTSearchStores";
import NTSearchStoresAddresses from "pages/NT/editOrCreateNT/NTSearchStoresAddress";
import NTSearchStoresNimaAddresses from "pages/NT/editOrCreateNT/NTSearchStoresNimaAddress";
import PropTypes from 'prop-types';
 
const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const NTCreateOrEditOptTras = ({formNT,setFormNT,setIsLoadingErrorData,errorsForm,setErrorsForm,validateformNT,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect,hasbeenshared}) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 

    const opt_tras_view_name = useSelector((state) => state.formatDIUser.opt_tras_view_name); 
    const opt_tras_view_contactname = useSelector((state) => state.formatDIUser.opt_tras_view_contactname); 
    const opt_tras_view_address = useSelector((state) => state.formatDIUser.opt_tras_view_address); 
    const opt_tras_view_cnae = useSelector((state) => state.formatDIUser.opt_tras_view_cnae); 
    const opt_tras_view_inscription = useSelector((state) => state.formatDIUser.opt_tras_view_inscription); 
    const opt_tras_view_opt = useSelector((state) => state.formatDIUser.opt_tras_view_opt); 
    const opt_tras_view_economicactivity = useSelector((state) => state.formatDIUser.opt_tras_view_economicactivity); 

    const opt_tras_handle_documnettype= useSelector((state) => state.formatDIUser.opt_tras_handle_documnettype); 
    const opt_tras_handle_documentid= useSelector((state) => state.formatDIUser.opt_tras_handle_documentid); 
    const opt_tras_handle_tradename= useSelector((state) => state.formatDIUser.opt_tras_handle_tradename); 
    const opt_tras_handle_name= useSelector((state) => state.formatDIUser.opt_tras_handle_name); 
    const opt_tras_handle_contactname= useSelector((state) => state.formatDIUser.opt_tras_handle_contactname); 
    const opt_tras_handle_address= useSelector((state) => state.formatDIUser.opt_tras_handle_address); 
    const opt_tras_handle_phone= useSelector((state) => state.formatDIUser.opt_tras_handle_phone); 
    const opt_tras_handle_email= useSelector((state) => state.formatDIUser.opt_tras_handle_email); 
    const opt_tras_handle_nima= useSelector((state) => state.formatDIUser.opt_tras_handle_nima); 
    const opt_tras_handle_cnae= useSelector((state) => state.formatDIUser.opt_tras_handle_cnae); 
    const opt_tras_handle_inscription= useSelector((state) => state.formatDIUser.opt_tras_handle_inscription); 
    const opt_tras_handle_opt= useSelector((state) => state.formatDIUser.opt_tras_handle_opt); 
    const opt_tras_handle_economicactivity= useSelector((state) => state.formatDIUser.opt_tras_handle_economicactivity); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);     
    const dispatch = useDispatch(); 
    const [postalCodeOptToSelect,setPostalCodeOptToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeOpt, setFilteredpostalCodeOpt] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeOpt, setHighlightedIndexPostalCodeOpt] = useState(-1); // Índice de la opción resaltada 
    const [documentIdOptToSelect,setDocumentIdOptToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdOpt, setFilteredDocumentIdOpt] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdOpt, setHighlightedIndexDocumentIdOpt] = useState(-1); // Índice de la opción resaltada 
    const [tradenameOptToSelect,setTradenameOptToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedOpt, setFilteredTradenamedOpt] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedOpt, setHighlightedIndexTradenamedOpt] = useState(-1); // Índice de la opción resaltada 
    const [optNimaToSelect,setOptNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredOptNima, setFilteredOptNima] = useState([]); // Opciones filtradas
    const [highlightedIndexOptNima, setHighlightedIndexOptNima] = useState(-1); // Índice de la opción resaltada 
         
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
     
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeOpt([]);
            setHighlightedIndexPostalCodeOpt(-1);
        return;
        }
        const filtered = postalCodeOptToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeOpt(filtered);
        setHighlightedIndexPostalCodeOpt(0);
    }, 300); 
    const handleSelectPostalCodeOpt = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormNT((formNT) => ({
            ...formNT,
            opt_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            opt_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeOpt([]);
        setHighlightedIndexPostalCodeOpt(-1);
    }; 
    const handleKeyDownDPostalCodeOpt = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeOpt.length === 0 && formNT.opt_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeOpt(postalCodeOptToSelect);
            setHighlightedIndexPostalCodeOpt(0);
        } else {
            setHighlightedIndexPostalCodeOpt((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeOpt.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeOpt((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOpt >= 0) {
            if (highlightedIndexPostalCodeOpt >= 0 && highlightedIndexPostalCodeOpt < filteredpostalCodeOpt.length) {
                handleSelectPostalCodeOpt(filteredpostalCodeOpt[highlightedIndexPostalCodeOpt]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeOptToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formNT.opt_tras_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormNT((formNT) => ({
                ...formNT,
                opt_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                opt_tras_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeOpt([]);
        setHighlightedIndexPostalCodeOpt(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdOpt([]);
            setHighlightedIndexDocumentIdOpt(-1);
            return;
        }
        const filtered = documentIdOptToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdOpt(filtered);
        setHighlightedIndexDocumentIdOpt(0);
    }, 300);
    const handleSelectDocumentIdOpt = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormNT((formNT) => ({
            ...formNT,
            opt_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdOpt([]);
        setHighlightedIndexDocumentIdOpt(-1);
    }; 
    const handleKeyDownDocumentIdOpt = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdOpt.length === 0 && formNT.opt_tras_documentid.trim() === "") {
            setFilteredDocumentIdOpt(documentIdOptToSelect);
            setHighlightedIndexDocumentIdOpt(0);
        } else {
            setHighlightedIndexDocumentIdOpt((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdOpt.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdOpt((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdOpt >= 0) {
        if (highlightedIndexDocumentIdOpt >= 0 && highlightedIndexDocumentIdOpt < filteredDocumentIdOpt.length) {
            handleSelectDocumentIdOpt(filteredDocumentIdOpt[highlightedIndexDocumentIdOpt]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdOptToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formNT.opt_tras_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormNT((formNT) => ({
            ...formNT,
            opt_tras_documentid: "",
            }));
        } 
        setFilteredDocumentIdOpt([]);
        setHighlightedIndexDocumentIdOpt(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedOpt([]);
            setHighlightedIndexTradenamedOpt(-1);
        return;
        }
        const filtered = tradenameOptToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedOpt(filtered);
        setHighlightedIndexTradenamedOpt(0);
    }, 300); 
    const handleSelectTradeNameOpt = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormNT((formNT) => ({
        ...formNT,
        opt_tras_tradename: store.tradename || "",
        opt_tras_documentid: store.documentid || formNT.opt_tras_documentid,
        
        }));
        setFilteredTradenamedOpt([]);
        setHighlightedIndexTradenamedOpt(-1);
    }; 
    const handleKeyDownTradenameOpt = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedOpt.length === 0 && formNT.opt_tras_tradename.trim() === "") {
            setFilteredTradenamedOpt(tradenameOptToSelect);
            setHighlightedIndexTradenamedOpt(0);
        } else {
            setHighlightedIndexTradenamedOpt((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedOpt.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedOpt((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedOpt >= 0) {
        if (highlightedIndexTradenamedOpt >= 0 && highlightedIndexTradenamedOpt < filteredTradenamedOpt.length) {
            handleSelectTradeNameOpt(filteredTradenamedOpt[highlightedIndexTradenamedOpt]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameOptToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formNT.opt_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormNT((formNT) => ({
            ...formNT,
            opt_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedOpt([]);
        setHighlightedIndexTradenamedOpt(-1);
        }
    }; 

    // Dentro del componente
    const debouncedHandleSearchOptTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredOptNima([]);
            setHighlightedIndexOptNima(-1);
        return;
        }
        const filtered = optNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredOptNima(filtered);
        setHighlightedIndexOptNima(0);
    }, 300); 
    const handleSelectOptTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormNT((formNT) => ({
        ...formNT,
        opt_tras_nima: nt.nima || ""
        }));
        setFilteredOptNima([]);
        setHighlightedIndexOptNima(-1);
    }; 

    const handleKeyDownOptTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredOptNima.length === 0 && formNT.opt_tras_nima.trim() === "") {
                const filtered = optNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredOptNima(filtered);
                setHighlightedIndexOptNima(0);
            } else {
                setHighlightedIndexOptNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredOptNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexOptNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOptNima >= 0) {
            if (highlightedIndexOptNima >= 0 && highlightedIndexOptNima < filteredOptNima.length) {
                handleSelectOptTrasNima(filteredOptNima[highlightedIndexOptNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = optNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formNT.opt_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormNT((formNT) => ({
                ...formNT, 
                opt_tras_nima: ""
            }));
        } 
        setFilteredOptNima([]);
        setHighlightedIndexOptNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
           if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeOpt([]);
            setHighlightedIndexPostalCodeOpt(-1);
            setFilteredDocumentIdOpt([]);
            setHighlightedIndexDocumentIdOpt(-1);
            setFilteredTradenamedOpt([]);
            setHighlightedIndexTradenamedOpt(-1);  
            setFilteredOptNima([]);
            setHighlightedIndexOptNima(-1);  
        }
    }, []);

    const handleChangeSelectDocumentType_Opt_Tras = (event) => {
        setFormNT(formNT => ({
            ...formNT,
            opt_tras_documnettype_id:event.target.value
        }));
    };
    
    const handleBlurSelectDocumentType_Opt_Tras = (e) => {
        handleChangeSelectDocumentType_Opt_Tras(e);
    };
    
    const handleChangeSelectRoadType_Opt_Tras = (event) => {
        setFormNT(formNT => ({
            ...formNT,
            opt_tras_roadtype_id : event.target.value 
        }));
    };
    
    const handleBlurSelectRoadType_Opt_Tras = (e) => {
        handleChangeSelectRoadType_Opt_Tras(e);
        setErrorsForm(validateformNT());
    };
       
    const handleChangeSelectCommunity_Opt_Tras = (event) => {
        setFormNT(formNT => ({
            ...formNT,
            opt_tras_community_id : event.target.value   
        }));
    };
    
    const handleBlurSelectCommunity_Opt_Tras = (e) => {
        handleChangeSelectCommunity_Opt_Tras(e);
        setErrorsForm(validateformNT());
    };

    const handleChangeDataEditForm_Opt_Tras = (e) => {
        const { name, value } = e.target;
        setFormNT(formNT => ({
          ...formNT,
          [name]: value,
        }));
        if (formNT.id===undefined  || formNT.id===null  || formNT.id==="" || formNT.id===0 || formNT.id==="0"){
            setFormNT(formNT => ({
                ...formNT,
                preiddoc_sheet: formNT.opt_tras_nima!==undefined && formNT.opt_tras_nima!==''?"NT00"+ formNT.opt_tras_nima:"NT00"
            }));
        }  
    };

    const handleBlurDataEditForm_Opt_Tras = (e) => {
        handleChangeDataEditForm_Opt_Tras(e);
        setErrorsForm(validateformNT());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };
 
    const deleteDateOptTras = (event) => {
        setFormNT(formNT => ({
          ...formNT,
            preiddoc_sheet: (formNT.id===undefined  || formNT.id===null  || formNT.id==="" || formNT.id===0 || formNT.id==="0")?"NT00":formNT.preiddoc_sheet,
            opt_tras_store_id:0,
            opt_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            opt_tras_documentid:"",
            opt_tras_tradename: "",
            opt_tras_name: "",
            opt_tras_contactname: "",
            opt_tras_roadtype_id: Number(DEFAULTROADTYE),
            opt_tras_street: "",
            opt_tras_country_id: Number(DEFAULTCOUNTRY),
            opt_tras_country_name:DEFAULTCOUNTRY_NAME,
            opt_tras_province_id: Number(DEFAULTPROVINCE),
            opt_tras_province_name:DEFAULTPROVINCE_NAME,
            opt_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            opt_tras_community_id: Number(DEFAULTCOMMUNITY),
            opt_tras_community_name: DEFAULTCOMMUNITY_NAME,
            opt_tras_phone: "",
            opt_tras_email: "",
            opt_tras_nima: "",
            opt_tras_cnae: "",
            opt_tras_inscription: "",
            opt_tras_opt: 0,
            opt_tras_licenseplate: "",
            opt_tras_economicactivity:""
        })); 
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            opt_tras_store_id:"",
            opt_tras_documnettype_id: "",
            opt_tras_documentid:"",
            opt_tras_tradename: "",
            opt_tras_name: "",
            opt_tras_contactname: "",
            opt_tras_roadtype_id: "",
            opt_tras_street: "",
            opt_tras_country_id: "",
            opt_tras_province_id: "",
            opt_tras_postalcode_id: "",
            opt_tras_postalcode_code:"",
            opt_tras_community_id: "",
            opt_tras_phone: "",
            opt_tras_email: "",
            opt_tras_nima: "",
            opt_tras_cnae: "",
            opt_tras_inscription: "",
            opt_tras_opt: "",
            opt_tras_licenseplate: "",
            opt_tras_economicactivity:""
        }));
        setErrorsForm(validateformNT());
    };

    const deleteDataSteetOptTras = (event) => {
        setFormNT(formNT => ({
          ...formNT,
            preiddoc_sheet: (formNT.id===undefined  || formNT.id===null  || formNT.id==="" || formNT.id===0 || formNT.id==="0")?"NT00":formNT.preiddoc_sheet,
            opt_tras_roadtype_id: Number(DEFAULTROADTYE),
            opt_tras_street: "",
            opt_tras_country_id: Number(DEFAULTCOUNTRY),
            opt_tras_country_name:DEFAULTCOUNTRY_NAME,
            opt_tras_province_id: Number(DEFAULTPROVINCE),
            opt_tras_province_name:DEFAULTPROVINCE_NAME,
            opt_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            opt_tras_community_id: Number(DEFAULTCOMMUNITY),
            opt_tras_community_name: DEFAULTCOMMUNITY_NAME,
            opt_tras_nima: "", 
            opt_tras_inscription: "",
            opt_tras_opt: 0,
        }));
        setErrorsForm(validateformNT());
    };
    
    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`nt/getexiststorebynumberdocument/`,token,formNT.opt_tras_documentid.replace(/[.\-/\\|]/g, ""));
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formNT.opt_tras_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`nt/getstorebynumberdocument`,token,formNT.opt_tras_documentid.replace(/[.\-/\\|]/g, ""),1);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormNT(formNT => ({
                            ...formNT,
                            preiddoc_sheet: (formNT.id===undefined  || formNT.id===null  || formNT.id==="" || formNT.id===0 || formNT.id==="0")?(getData.nima_opt_tras!==undefined && getData.nima_opt_tras!==''?"NT00"+ getData.nima_opt_tras:"NT00"):formNT.preiddoc_sheet,
                            
                            opt_tras_store_id: getData.store_id,
                            opt_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            opt_tras_tradename: getData.tradename,
                            opt_tras_name: getData.name,
                            opt_tras_contactname: getData.contacperson,
                            opt_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            opt_tras_street: getData.street,
                            opt_tras_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            opt_tras_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            opt_tras_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            opt_tras_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            opt_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            opt_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            opt_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            opt_tras_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            opt_tras_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,  
                            opt_tras_phone: getData.phone,
                            opt_tras_email: getData.email,
                            opt_tras_nima: getData.nima_opt_tras,
                            opt_tras_cnae: getData.cnae,
                            opt_tras_inscription: getData.pygr_opt_tras,
                            opt_tras_opt: getData.opt_opt_tras,
                            opt_tras_licenseplate: getData.licenseplate,
                            opt_tras_economicactivity:getData.economicactivity
                        }));
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formNT.opt_tras_documentid && formNT.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formNT.opt_tras_documentid,errorsForm.opt_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTROADTYE,DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTTYPEOFDOCUMENT,DEFAULTPROVINCE,DEFAULTPROVINCE_NAME,setFormNT,formNT.opt_tras_store_id]);
   
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdOpt = async () => {
            try {
            const getData = await helpHttp().get2(ENDPOINT,`nt/getlistdocumentidnt/`,token,
                (formNT.opt_tras_documentid!==undefined && formNT.opt_tras_documentid!==null && formNT.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formNT.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setDocumentIdOptToSelect(getData); 
            }
            } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formNT.opt_tras_documentid && formNT.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdOpt();
            }
        } else{
            setDocumentIdOptToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formNT.opt_tras_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameOpt = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`nt/getlisttradenament/`,token,
                    (formNT.opt_tras_tradename!==undefined && formNT.opt_tras_tradename!==null && formNT.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formNT.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameOptToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formNT.opt_tras_tradename && formNT.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameOpt();
            }
        } else{
            setTradenameOptToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formNT.opt_tras_tradename,expanded]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeOpt = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`nt/getlistpostalcodent/`,token,
                    (formNT.opt_tras_postalcode_code!==undefined && formNT.opt_tras_postalcode_code!==null && formNT.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formNT.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeOptToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formNT.opt_tras_postalcode_code && formNT.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeOpt();
            } 
        } else{
            setPostalCodeOptToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formNT.opt_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormNT]);
    
     useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaOpt = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchnt/getlistnimas`,token,formNT.opt_tras_store_id, 
                    (formNT.opt_tras_nima!==undefined && formNT.opt_tras_nima!==null && formNT.opt_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formNT.opt_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setOptNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formNT.opt_tras_store_id && formNT.opt_tras_store_id!==null && formNT.opt_tras_store_id!=="" && formNT.opt_tras_store_id!=="0" && formNT.opt_tras_store_id!==0){
                fetchDataNimaOpt(); 
            }else{
                setOptNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formNT,expanded,setFormNT,formNT.opt_tras_store_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DocuentType')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="opt_tras_documnettype_id"
                    name="opt_tras_documnettype_id"
                    value={ (formNT.opt_tras_documnettype_id === undefined || formNT.opt_tras_documnettype_id ===null || formNT.opt_tras_documnettype_id ===""
                        || formNT.opt_tras_documnettype_id ==="0" || formNT.opt_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formNT.opt_tras_documnettype_id}
                    inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    variant="outlined"
                    onBlur={handleBlurSelectDocumentType_Opt_Tras}
                    onChange={handleChangeSelectDocumentType_Opt_Tras}
                    disabled={!opt_tras_handle_documnettype || hasbeenshared}
                    helperText={errorsForm.opt_tras_documnettype_id!=null && errorsForm.opt_tras_documnettype_id!==""?t(errorsForm.opt_tras_documnettype_id):""}
                    select
                    SelectProps={{
                        native: true,
                        value: (formNT.opt_tras_documnettype_id === undefined || formNT.opt_tras_documnettype_id ===null || formNT.opt_tras_documnettype_id ===""
                            || formNT.opt_tras_documnettype_id ==="0" || formNT.opt_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formNT.opt_tras_documnettype_id
                    }}>
                    <option key={0} value=""/>
                    {documentTypesToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.name}
                        </option>
                    ))}
                </TextField>  
                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CIF')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <span style={{ position: "relative" }}>
                    <TextField
                        id="opt_tras_documentid"
                        name="opt_tras_documentid"
                        value={formNT.opt_tras_documentid}
                        onChange={(e) => {
                            setFormNT(prev => ({
                            ...prev,
                            opt_tras_documentid: e.target.value.toUpperCase()
                            }));
                            debouncedHandleSearchDocumentId(e.target.value);
                        }}
                        onKeyDown={handleKeyDownDocumentIdOpt}
                        onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                            handleBlur();
                            }
                        }}
                        label={errorsForm.opt_tras_documentid!=null && errorsForm.opt_tras_documentid!==""?t(errorsForm.opt_tras_documentid):t('PlaceHolder_FORM_CIF')}
                        placeholder={t('PlaceHolder_FORM_CIF')}
                        variant="standard"
                        inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        disabled={!opt_tras_handle_documentid || hasbeenshared}
                    /> 
                    {/* Desplegable dinámico */}
                    {filteredDocumentIdOpt.length > 0 && (
                        <div
                            className="dropdown-class"
                            style={{
                            position: "absolute",
                            left:'0px',
                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                            borderRadius: "4px",
                            marginTop: "4px",
                            maxHeight: "200px",
                            maxWidth: "400px",
                            overflowY: "auto",
                            width: "250%",
                            fontSize: '18px',
                            backgroundColor: "#f8f9fa", // Fondo gris claro
                            zIndex: 1000,
                            }}
                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                        >
                        {filteredDocumentIdOpt.map((store, index) => (
                            <MenuItem
                                key={store.id}
                                onClick={() => handleSelectDocumentIdOpt(store)}
                                style={{
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderBottom: "1px solid #eee",
                                    fontSize: '18px',
                                    backgroundColor:
                                    index === highlightedIndexDocumentIdOpt ? "#4e73df" : "transparent",
                                    color: index === highlightedIndexDocumentIdOpt ? "white" : "black",
                                }}
                            >
                                {store.documentid} - {store.tradename}
                            </MenuItem>
                            ))}
                        </div>
                    )}
                </span>  
                &nbsp;&nbsp;
               <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDateOptTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                    <IconButton  size="small" className={`edit-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={searchFormStore}>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>
                }
                </div>
            </div> 
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="opt_tras_tradename"
                            name="opt_tras_tradename"
                            value={formNT.opt_tras_tradename}
                            onChange={(e) => {
                                setFormNT(prev => ({
                                    ...prev,
                                    opt_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameOpt}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.opt_tras_tradename!=null && errorsForm.opt_tras_tradename!==""?t(errorsForm.opt_tras_tradename):t('PlaceHolder_FORM_TRADENAME')}
                            placeholder={t('PlaceHolder_FORM_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            disabled={!opt_tras_handle_tradename || hasbeenshared}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedOpt.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedOpt.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameOpt(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedOpt ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedOpt ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
            </div>
            {opt_tras_view_name &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_name" 
                        name="opt_tras_name"
                        value={formNT.opt_tras_name}
                        inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_name!=null && errorsForm.opt_tras_name!==""?t(errorsForm.opt_tras_name):t('PlaceHolder_FORM_NAME')}
                        placeholder={t('PlaceHolder_FORM_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Opt_Tras}
                        onChange={handleChangeDataEditForm_Opt_Tras}
                        disabled={!opt_tras_handle_name || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {opt_tras_view_contactname &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_contactname" 
                        name="opt_tras_contactname"
                        value={formNT.opt_tras_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_contactname!=null && errorsForm.opt_tras_contactname!==""?t(errorsForm.opt_tras_contactname):t('PlaceHolder_FORM_CONTACT')}
                        placeholder={t('PlaceHolder_FORM_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Opt_Tras}
                        onChange={handleChangeDataEditForm_Opt_Tras}
                        disabled={!opt_tras_handle_contactname || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {opt_tras_view_address &&
                <>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_RoadType')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="opt_tras_roadtype"
                                name="opt_tras_roadtype"
                                value={ (formNT.opt_tras_roadtype_id === undefined || formNT.opt_tras_roadtype_id ===null || formNT.opt_tras_roadtype_id ===""
                                    || formNT.opt_tras_roadtype_id ==="0" || formNT.opt_tras_roadtype_id ===0)?Number(DEFAULTROADTYE):formNT.opt_tras_roadtype_id}
                                inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurSelectRoadType_Opt_Tras}
                                onChange={handleChangeSelectRoadType_Opt_Tras}
                                disabled={!opt_tras_handle_address || hasbeenshared}
                                helperText={errorsForm.opt_tras_roadtype_id!=null && errorsForm.opt_tras_roadtype_id!==""?t(errorsForm.opt_tras_roadtype_id):""}
                                select
                                SelectProps={{
                                    native: true,
                                    value: (formNT.opt_tras_roadtype_id === undefined || formNT.opt_tras_roadtype_id ===null || formNT.opt_tras_roadtype_id ===""
                                        || formNT.opt_tras_roadtype_id ==="0" || formNT.opt_tras_roadtype_id ===0)?Number(DEFAULTROADTYE): formNT.opt_tras_roadtype_id
                                }}>
                                <option key={0} value=""/>
                                {roadTypesToSelect.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {i18n.language==="es"?option.namees:option.nameen}
                                    </option>
                                ))}
                            </TextField>  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Address')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="opt_tras_street" 
                                name="opt_tras_street"
                                value={formNT.opt_tras_street}
                                inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.opt_tras_street!=null && errorsForm.opt_tras_street!==""?t(errorsForm.opt_tras_street):t('PlaceHolder_FORM_Address')}
                                placeholder={t('PlaceHolder_FORM_Address')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Opt_Tras}
                                onChange={handleChangeDataEditForm_Opt_Tras}
                                disabled={!opt_tras_handle_address || hasbeenshared}
                            />
                        </div>
                        &nbsp;&nbsp;
                        <IconButton  size="small"className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDataSteetOptTras}>
                            <DeleteIcon style={{fontSize: 28}}/>
                        </IconButton>
                        &nbsp;&nbsp;
                        {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formNT.opt_tras_documentid!==undefined && formNT.opt_tras_documentid!=="") ?
                            <IconButton  size="small" className={`edit-${
                                (formNT.opt_tras_store_id===undefined
                                    || formNT.opt_tras_store_id===""
                                    || formNT.opt_tras_store_id==="0"
                                    || formNT.opt_tras_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                    disabled={(formNT.opt_tras_store_id===undefined
                                    || formNT.opt_tras_store_id===""
                                    || formNT.opt_tras_store_id==="0"
                                    || formNT.opt_tras_store_id===0 || hasbeenshared)}  onClick={searchFormStoreAddress}>
                                <SearchIcon style={{fontSize: 28}}/> 
                            </IconButton>:
                            <IconButton  size="small" className="edit-noselect-button" disabled>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>
                        }
                    </div>
 
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_PostalCode')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <span style={{ position: "relative" }}>
                                <TextField
                                    id="opt_tras_postalcode_code"
                                    name="opt_tras_postalcode_code"
                                    value={formNT.opt_tras_postalcode_code}
                                    onChange={(e) => {
                                          setFormNT(prev => ({
                                            ...prev,
                                            opt_tras_postalcode_code: e.target.value.toUpperCase()
                                        }));
                                        debouncedHandleSearchPostalCode(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownDPostalCodeOpt}
                                    onBlur={(event) => {
                                        if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            const inputPostalCode = formNT.opt_tras_postalcode_code.trim().toUpperCase();
                                            const matchedPostal = postalCodeOptToSelect.find((postal) => {
                                            const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                            return normalizedPostal === inputPostalCode;
                                            });

                                            if (matchedPostal) {
                                                setFormNT((prev) => ({
                                                    ...prev,
                                                    opt_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                                    opt_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                                    opt_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                                    opt_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                                }));
                                            } else {
                                                setFormNT((prev) => ({
                                                    ...prev,
                                                    opt_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                                    opt_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                                    opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                                    opt_tras_province_id: Number(DEFAULTPROVINCE),
                                                }));
                                            }
                                            setFilteredpostalCodeOpt([]);
                                            setHighlightedIndexPostalCodeOpt(-1);
                                        }
                                    }}
                                    label={errorsForm.opt_tras_postalcode_code!=null && errorsForm.opt_tras_postalcode_code!==""?t(errorsForm.opt_tras_postalcode_code):t('Text_FORM_PostalCode')}
                                    placeholder={t('Text_FORM_PostalCode')}
                                    variant="standard"
                                    inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                />  
                                {/* Desplegable dinámico */}
                                {filteredpostalCodeOpt.length > 0 && (
                                    <div
                                        className="dropdown-class"
                                        style={{
                                        position: "absolute",
                                        left:'0px',
                                        border: "2px solid #4e73df", // Borde azul (#4e73df)
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "350%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa", // Fondo gris claro
                                        zIndex: 1000,
                                        }}
                                        onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                        {filteredpostalCodeOpt.map((postal, index) => (
                                        <MenuItem
                                            key={postal.id}
                                            onClick={() => handleSelectPostalCodeOpt(postal)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor:
                                                index === highlightedIndexPostalCodeOpt ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexPostalCodeOpt ? "white" : "black",
                                            }}
                                        >
                                            {postal.postalcode} - {postal.name}
                                        </MenuItem>
                                        ))}
                                    </div>
                                )}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Locality')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="opt_tras_postalcode_name" 
                                name="opt_tras_postalcode_name"
                                value={formNT.opt_tras_postalcode_name}
                                inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.opt_tras_postalcode_name!=null && errorsForm.opt_tras_postalcode_name!==""?t(errorsForm.opt_tras_postalcode_name):t('Text_FORM_Locality')}
                                placeholder={t('Text_FORM_Locality')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Opt_Tras}
                                onChange={handleChangeDataEditForm_Opt_Tras}
                                disabled
                            />  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Community')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="opt_tras_community_id"
                                name="opt_tras_community_id"
                                value={ (formNT.opt_tras_community_id === undefined || formNT.opt_tras_community_id ===null || formNT.opt_tras_community_id ===""
                                    || formNT.opt_tras_community_id ==="0" || formNT.opt_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formNT.opt_tras_community_id}
                                inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurSelectCommunity_Opt_Tras}
                                onChange={handleChangeSelectCommunity_Opt_Tras}
                                disabled={!opt_tras_handle_address || hasbeenshared}
                                helperText={errorsForm.opt_tras_community_id!=null  && errorsForm.opt_tras_community_id!==""?t(errorsForm.opt_tras_community_id):""}
                                select
                                SelectProps={{
                                    native: true,
                                    value: (formNT.opt_tras_community_id === undefined || formNT.opt_tras_community_id ===null || formNT.opt_tras_community_id ===""
                                        || formNT.opt_tras_community_id ==="0" || formNT.opt_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formNT.opt_tras_community_id
                                }}>
                                {communityToSelect.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {i18n.language==="es"?option.namees:option.nameen}
                                    </option>
                                ))}
                            </TextField>
                        </div>
                    </div>
                </>
            }    
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_phone" 
                        name="opt_tras_phone"
                        value={formNT.opt_tras_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_phone!=null && errorsForm.opt_tras_phone!==""?t(errorsForm.opt_tras_phone):t('PlaceHolder_FORM_Phone')}
                        placeholder={t('PlaceHolder_FORM_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Opt_Tras}
                        onChange={handleChangeDataEditForm_Opt_Tras}
                        disabled={!opt_tras_handle_phone || hasbeenshared}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_email" 
                        name="opt_tras_email"
                        value={formNT.opt_tras_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_email!=null && errorsForm.opt_tras_email!==""?t(errorsForm.opt_tras_email):t('PlaceHolder_FORM_Email')}
                        placeholder={t('PlaceHolder_FORM_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Opt_Tras}
                        onChange={handleChangeDataEditForm_Opt_Tras}
                        disabled={!opt_tras_handle_email || hasbeenshared}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                   <span style={{ position: "relative" }}>
                        <TextField
                            id="opt_tras_nima"
                            name="opt_tras_nima"
                            value={formNT.opt_tras_nima}
                            onChange={(e) => {
                                setFormNT(prev => ({
                                ...prev,
                                opt_tras_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchOptTrasNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownOptTrasNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.opt_tras_nima!=null && errorsForm.opt_tras_nima!==""?t(errorsForm.opt_tras_nima):t('PlaceHolder_FORM_NIMA')}
                            placeholder={t('PlaceHolder_FORM_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            disabled={!opt_tras_handle_nima || hasbeenshared}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredOptNima.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredOptNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectOptTrasNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexOptNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexOptNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formNT.opt_tras_documentid!==undefined && formNT.opt_tras_documentid!=="") ?
                        <IconButton  size="small" className={`edit-${
                            (formNT.opt_tras_store_id===undefined
                                || formNT.opt_tras_store_id===""
                                || formNT.opt_tras_store_id==="0"
                                || formNT.opt_tras_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                disabled={(formNT.opt_tras_store_id===undefined
                                || formNT.opt_tras_store_id===""
                                || formNT.opt_tras_store_id==="0"
                                || formNT.opt_tras_store_id===0 || hasbeenshared)}  onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>
                    }       
                </div>
            </div>  
            
            { (opt_tras_view_inscription || opt_tras_view_opt) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {opt_tras_view_inscription &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_INSCRIPTION')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="opt_tras_inscription" 
                                name="opt_tras_inscription"
                                value={formNT.opt_tras_inscription}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !opt_tras_view_opt?350:350,  fontSize: '18px'}, maxLength: 50 }}
                                label={errorsForm.opt_tras_inscription!=null && errorsForm.opt_tras_inscription!==""?t(errorsForm.opt_tras_inscription):t('PlaceHolder_FORM_INSCRIPTION')}
                                placeholder={t('PlaceHolder_FORM_INSCRIPTION')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Opt_Tras}
                                onChange={handleChangeDataEditForm_Opt_Tras}
                                disabled={!opt_tras_handle_inscription || hasbeenshared}
                            /> 
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                        </>
                    }
                    {opt_tras_view_opt &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_OPT')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="opt_tras_opt"
                                name="opt_tras_opt"
                                value={ (formNT.opt_tras_opt === undefined || formNT.opt_tras_opt ===null || formNT.opt_tras_opt ===""
                                    || formNT.opt_tras_opt ==="0" || formNT.opt_tras_opt ===0)?0:formNT.opt_tras_opt}
                                inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurDataEditForm_Opt_Tras}
                                onChange={handleChangeDataEditForm_Opt_Tras} 
                                helperText={errorsForm.opt_tras_opt!=null?t(errorsForm.opt_tras_opt):""}
                                disabled={!opt_tras_handle_opt || hasbeenshared}
                                select
                                SelectProps={{
                                    native: true,
                                    value: (formNT.opt_tras_opt === undefined || formNT.opt_tras_opt ===null || formNT.opt_tras_opt ===""
                                        || formNT.opt_tras_opt ==="0" || formNT.opt_tras_opt ===0)?0: formNT.opt_tras_opt
                                }}>
                                <option key={0} value=""/>
                                {optTypeToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.code} - {option.namees.substring(0,20)}
                                </option>
                                ))}
                            </TextField>  
                        </>
                    }
                    </div>
                </div> 
            } 
            { (opt_tras_view_cnae ) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {opt_tras_view_cnae &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CNAE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="opt_tras_cnae" 
                                name="opt_tras_cnae"
                                value={formNT.opt_tras_cnae}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: (i18n.language==='es'?388:399),  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.opt_tras_cnae!=null && errorsForm.opt_tras_cnae!==""?t(errorsForm.opt_tras_cnae):t('PlaceHolder_FORM_CNAE')}
                                placeholder={t('PlaceHolder_FORM_CNAE')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Opt_Tras}
                                onChange={handleChangeDataEditForm_Opt_Tras}
                                disabled={!opt_tras_handle_cnae || hasbeenshared}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </>
                    } 
                    </div>
                </div> 
            }
            {opt_tras_view_economicactivity &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Economicactivity')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_economicactivity" 
                        name="opt_tras_economicactivity"
                        value={formNT.opt_tras_economicactivity}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: i18n.language==='es'?797:823,  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.opt_tras_economicactivity!=null && errorsForm.opt_tras_economicactivity!==""?t(errorsForm.opt_tras_economicactivity):t('PlaceHolder_FORM_Economicactivity')}
                        placeholder={t('PlaceHolder_FORM_Economicactivity')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Opt_Tras}
                        onChange={handleChangeDataEditForm_Opt_Tras}
                        disabled={!opt_tras_handle_economicactivity || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            <NTSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Opt_Tras"}
                setFormNT={setFormNT}
            />
            <NTSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Opt_Tras"}
                setFormNT={setFormNT}
                titleTable={formNT.opt_tras_tradename}
                store_id={formNT.opt_tras_store_id}
                priority={1}
            /> 
            <NTSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Opt_Tras"}
                setFormNT={setFormNT}
                titleTable={formNT.opt_tras_tradename}
                store_id={formNT.opt_tras_store_id} 
            />


        </> 
    )
}

NTCreateOrEditOptTras.propTypes = {
    formNT: PropTypes.object.isRequired,
    setFormNT: PropTypes.func.isRequired, 
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateformNT: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired, 
    optTypeToSelect: PropTypes.array.isRequired,
    hasbeenshared: PropTypes.bool.isRequired
  };
  
  export default NTCreateOrEditOptTras;